import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const CreateUserAccount = () => {
  const navigate = useNavigate();

  const handleCreateAccount = (event) => {
    event.preventDefault();
    navigate('/verify-email');
  };
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-200">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-sm">
        <h2 className="text-2xl font-bold mb-4">Create an Account</h2>
        <form onSubmit={handleCreateAccount}>
          <div className="mb-4">
            <label htmlFor="name" className="block text-gray-700">Your Name</label>
            <input type="text" id="name" className="w-full p-2 border rounded-md" required />
          </div>
          <div className="mb-4">
            <label htmlFor="phone" className="block text-gray-700">Your Mobile No</label>
            <input type="text" id="phone" className="w-full p-2 border rounded-md" required />
          </div>
          <div className="mb-4">
            <label htmlFor="password" className="block text-gray-700">Password</label>
            <input type="password" id="password" className="w-full p-2 border rounded-md" required />
          </div>
          <p className="text-gray-600 mb-4">
            To verify your mobile, we will send you a text message with a temporary code. Message and data rates may apply.
          </p>
          <button type="verifyMobile" className="w-full bg-green-500 text-white py-2 rounded-md hover:bg-green-700">Verify Your mobile</button>
        </form>
        <div className="mt-4 text-center">
          <p className="text-gray-700">Already have an account? <Link to="/login" className="text-blue-500 hover:underline">Login</Link></p>
        </div>
      </div>
    </div>
  );
};
export default CreateUserAccount;
